"use client";

import type {ComponentProps} from "react";
import AssistantContentParts, {type AssistantContentPart} from "@/components/ask/AssistantContentParts";
import ApprovalReview, {type ApprovalPart} from "./ApprovalReview";

type Props = ComponentProps<typeof AssistantContentParts> & Omit<ComponentProps<typeof ApprovalReview>, "parts">;

/** Approval groups form visible boundaries, preserving the order of follow-up answers. */
export default function ApprovalContentParts({contentParts, conversationId, messageId, approvalMessageIds, activeMessageId, disabled, onRespond, ...props}: Props) {
   const groups: {approval: boolean; parts: AssistantContentPart[]; start: number}[] = [];
   contentParts.forEach((part, index) => {
      const approval = !props.isUser && part.type === "functionCall" && !!part.data.approval;
      const previous = groups.at(-1);
      const snapshot = part.type === "functionCall" && part.data.approval?.proposal != null;
      const prior = previous?.parts.at(-1);
      const previousSnapshot = prior?.type === "functionCall" && prior.data.approval?.proposal != null;
      if (previous?.approval === approval && !snapshot && !previousSnapshot) previous.parts.push(part);
      else groups.push({approval, parts: [part], start: index});
   });
   return <>{groups.map(group => group.approval ? <ApprovalReview
      key={(group.parts[0] as ApprovalPart).data.approval!.id}
      parts={group.parts as ApprovalPart[]} conversationId={conversationId} messageId={messageId} approvalMessageIds={approvalMessageIds}
      activeMessageId={activeMessageId} disabled={disabled} onRespond={onRespond}
   /> : <AssistantContentParts key={`content:${group.start}`} {...props} conversationId={conversationId} contentParts={group.parts} />)}</>;
}
